export default {
  state: {
    marketingProgramSelectData:{
      name:'',
      url:'',
    },
  },
  //同步更新数据
  mutations: {
    updateMarketingProgramSelectData(state,data){
      state.marketingProgramSelectData = data
    },

  },
  getters: {

  },
  //异步更新数据
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/components/chat/marketingProgramData.js